import { render, staticRenderFns } from "./liveManage.vue?vue&type=template&id=be169d9c&"
import script from "./liveManage.vue?vue&type=script&lang=js&"
export * from "./liveManage.vue?vue&type=script&lang=js&"
import style0 from "./liveManage.vue?vue&type=style&index=0&id=be169d9c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports